module.exports = __webpack_public_path__ + "static/media/desktop-icons-buttons-page-navigation-rigth-arrow-disabled.768dc469.svg";